import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription, throwError } from 'rxjs';
import { AuthModel, UserModel } from '../auth.models';
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { NotificationType } from '../../interfaces/notification.enums';
import { ClientRoles } from '../../services/auth/auth.models'


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy{

  public loginForm: FormGroup;
  public isLoading = false;
  public submitted = false;
  public submittedLogin = false;

  private subs: Array<Subscription> = [];
  public currentUser: AuthModel;

  constructor(
    public formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthenticationService,
    private toastr: ToastrService
  ) { }

  owlcarousel = [
    {
      title: "Bienvenido a Morelos",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.",
    },
    {
      title: "Bienvenido a Morelos",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.",
    },
    {
      title: "Bienvenido a Morelos",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.",
    }
  ]
  owlcarouselOptions = {
    loop: true,
    items: 1,
    dots: true
  };

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      password: ['', Validators.required]
    })
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public get formState() {
    return this.loginForm.controls
  }

  private loginUser(): UserModel {
    return {
        email: this.loginForm.controls['email'].value,
        password: this.loginForm.controls['password'].value
    }
  }

  public onSubmit(): void {
    this.submittedLogin = true;

    if (this.loginForm.invalid) {
      return;
    }

    const user: UserModel = this.loginUser();
    this.isLoading = true;
    this.subs.push(
      this.authService.login(user)
        .pipe(
          map(() => {
            this.authService.currentUser.subscribe((authenticatedUser: AuthModel) => this.currentUser = authenticatedUser);
            setTimeout(() => {
              if(this.authService.currentUserValue.roles === 'superadmin' || this.authService.currentUserValue.roles === 'admin'){
                this.router.navigateByUrl('/dashboard');
              }
              if(this.authService.currentUserValue.roles === 'funcionario'){
                this.router.navigateByUrl('/reports/my-area-reports');
              }else {
                this.router.navigateByUrl('/reports/my-user-reports');
              }
            },500)
          }),
          catchError(err => {
            this.isLoading = false;
            this.sendNotification('Error al acceder', err.error?.message, NotificationType.error);
            return throwError(err);
          })
        ).subscribe()
    );
  }

  private sendNotification(title: string = 'Atención Ciudadana', message: string, type: string): void {
    this.toastr[type](message, title, { timeOut: 3500 });
  }

}
